var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 59,
    viewBox: "0 0 89 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.5887 47.7399C77.2045 74.1696 -8.2441 42.2885 1.98356 16.1758C11.3678 -10.2519 96.8164 21.6292 86.5887 47.7399Z",
    fill: "#C59EF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4114 23.4197C73.5534 48.8505 18.3255 36.1041 1.34532 20.8814C0.834446 45.4379 77.2037 72.7501 86.59 47.7372C89.2581 40.5836 83.8175 31.3925 73.4114 23.4197Z",
    fill: "#C59EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9002 51.1929C49.5559 52.9692 4.10182 36.8755 6.84737 18.0827C7.11661 17.0408 8.74214 17.4433 8.47358 18.498C6.77267 36.1647 50.6275 51.2865 57.9312 49.5128C58.9859 49.5283 58.9772 51.2171 57.9002 51.1929Z",
    fill: "#162647"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3153 58.9665C46.0058 59.2364 20.2303 49.0363 8.0614 36.0368C-6.35359 21.5734 -0.787742 6.63811 19.5835 5.15125C38.5788 3.12725 67.4815 13.9069 80.5099 27.8803C97.414 44.6444 85.6685 59.8092 64.3153 58.9665ZM24.2729 7.67804C5.4236 7.02918 -5.27193 18.9725 10.0248 34.1421C23.4281 49.1601 72.1043 68.2128 85.3111 47.2627C89.0878 24.0086 43.8896 7.12274 24.2729 7.67804Z",
    fill: "#162647"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8501 31.2713C67.6289 49.8494 14.9331 30.1904 23.1509 12.7323C32.2134 -11.4903 81.8695 7.03794 72.8501 31.2713Z",
    fill: "#81E0DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0369 10.1954C58.3441 21.6717 37.493 24.1453 22.378 16.0231C20.2679 31.3871 67.7944 49.245 72.8493 31.272C75.4649 24.2611 72.5377 16.2183 66.0369 10.1954Z",
    fill: "#81E0DE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3514 40.346C55.6209 40.346 49.8067 39.0368 42.6423 36.3646C30.1308 31.3783 17.8206 25.3939 21.872 12.2551C32.0545 -13.5918 83.3672 5.55239 74.1276 31.7492C72.1205 37.5075 66.8514 40.4557 60.3514 40.346ZM43.098 2.61232C34.3727 2.61232 26.9363 6.48732 24.429 13.2082C20.0243 25.0149 37.7657 31.6335 43.5961 33.8082C54.8415 37.521 66.6724 41.604 71.5719 30.7954C77.1841 17.728 58.2312 1.69758 43.098 2.61232Z",
    fill: "#162647"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77654 13.4566C6.18693 12.1299 15.6566 7.77094 15.8788 10.5441C15.8949 11.9461 12.1734 10.8981 10.3722 13.2089C10.2086 13.3745 9.9926 13.4566 9.77654 13.4566Z",
    fill: "#162647"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4489 51.7475C67.5295 51.6169 65.6462 52.117 65.626 50.7379C65.6691 50.2761 66.0809 49.9362 66.54 49.98C71.7652 50.4666 77.1594 48.9279 81.34 45.7556C82.1935 45.0859 83.2355 46.4462 82.3551 47.0931C78.3926 50.0998 73.4204 51.7475 68.4489 51.7475Z",
    fill: "#162647"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1583 42.2198C50.8373 42.2407 30.2298 35.1241 23.3811 26.767C18.3491 20.9117 16.0794 15.9948 22.7753 11.9797C23.7574 11.4897 24.4972 13.0028 23.5259 13.4821C12.72 19.8395 32.7621 33.3922 40.9254 35.9258C53.2201 40.3534 64.8781 43.3251 72.1643 36.7563C73.0939 35.328 70.3624 34.3945 71.3135 33.1856C71.6346 32.8511 72.1663 32.841 72.5009 33.162C77.9334 39.6439 66.8152 42.0886 60.1583 42.2198Z",
    fill: "#162647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfo);
export default __webpack_public_path__ + "static/media/ufo.8395fadb278c0ff33e059f4e15f89a4a.svg";
export { ForwardRef as ReactComponent };